// extracted by mini-css-extract-plugin
module.exports = {"headerText":"TheFamily_headerText__2sngs","werkplekHeader":"TheFamily_werkplekHeader__2sMEg","werkplekText":"TheFamily_werkplekText__2oGj1"};